import DiamondIcon from "@mui/icons-material/Diamond";
import { Avatar, MenuItem as MuiMenuItem, MenuItemProps, Tooltip } from "@mui/material";

/**
 * @remarks MuiMenuItem component styles are defined globally and should be adjusted only in the [src/theme/mui-menu-item.ts](src/theme/mui-menu-item.ts) file.
 *
 * See [MUIDocs](https://v5.mui.com/material-ui/customization/theme-components/#theme-style-overrides) to get more information.
 * */

const MenuItem = ({
  value,
  disabled,
  withSubscribeIcon = false,
  "data-testid": dataTestId,
  children,
  tooltipTitle,
  ...rest
}: MenuItemProps<"li", { withSubscribeIcon?: boolean }> & {
  "data-testid": string;
  tooltipTitle?: string | null;
}) => {
  const content = (
    <MuiMenuItem
      value={value}
      disabled={disabled}
      data-testid={dataTestId}
      sx={{
        "&.Mui-disabled > *:not(.MuiAvatar-root)": { opacity: 0.38 },
      }}
      {...rest}
    >
      {children}
      {withSubscribeIcon && (
        <Avatar
          sx={{
            backgroundColor: "gold.light",
            width: "24px",
            height: "24px",
            marginLeft: "12px",
          }}
        >
          <DiamondIcon sx={{ color: "gold.main", fontSize: "18px", marginTop: "2px" }} />
        </Avatar>
      )}
    </MuiMenuItem>
  );

  if (tooltipTitle) {
    return (
      <Tooltip title={tooltipTitle} placement="top" arrow>
        <span>{content}</span>
      </Tooltip>
    );
  }

  return content;
};

export { MenuItem };
